import { useState, useSyncExternalStore } from 'react';

const subscribeToFullscreen = (onChange: () => void): (() => void) => {
  document.addEventListener('fullscreenchange', onChange);

  return (): void => {
    document.removeEventListener('fullscreenchange', onChange);
  };
};

const isDocumentFullscreen = (): boolean => Boolean(document.fullscreenElement);

const isServerFullscreen = (): boolean => false;

// A layout switch during fullscreen would remove the fullscreen element and end the fullscreen
const useValueOutsideFullscreen = <T>(value: T): T => {
  const isFullscreen: boolean = useSyncExternalStore(
    subscribeToFullscreen,
    isDocumentFullscreen,
    isServerFullscreen
  );
  const [stableValue, setStableValue] = useState<T>(value);

  if (!isFullscreen && stableValue !== value) {
    setStableValue(value);
  }

  return isFullscreen ? stableValue : value;
};

export default useValueOutsideFullscreen;
